import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { Router  } from '@angular/router';
import { HotTableRegisterer } from '@handsontable/angular';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { LabService } from 'src/app/_service/lab.service';
import { LabTestModalComponent } from '../lab-test-modal/lab-test-modal.component';
import { AddSubcategoryComponent } from '../../lab_section/add-subcategory/add-subcategory.component';
import { AddCategoryComponent } from '../../lab_section/add-category/add-category.component';
declare var $: any;
import * as XLSX from 'xlsx';
import { MoveSurgeryLeadComponent } from '../move-surgery-lead/move-surgery-lead.component';
import { PlanShareModalComponent } from '../../plans/plan-share-modal/plan-share-modal.component';
import { LabPaymentModalComponent } from '../../lab_section/lab-payment-modal/lab-payment-modal.component';
@Component({
  selector: 'app-lab-sheetview',
  templateUrl: './lab-sheetview.component.html',
  styleUrls: ['./lab-sheetview.component.css']
})
export class LabSheetviewComponent implements OnInit {

  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
  @ViewChild('followupdateRangeStart', {static: false}) followupdateRangeStart: ElementRef;
  @ViewChild('followupdateRangeEnd', {static: false}) followupdateRangeEnd: ElementRef;


  @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator;
  @ViewChild('csvUploadTest', {static: false}) csvUploadTest: ElementRef;
  @ViewChild('csvUploadLead', {static: false}) csvUploadLead: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  


  leads:any=[];private hotRegisterer = new HotTableRegisterer();leadStatusOpt=[];userId:string;
  id = 'hotInstance'; settings = {colHeaders: true };bds=[];leadallStatus=[];allbds=[];ActionOpt=[];hideColumn:any;gender=[];
  perpage:number=25;length:number=0;pageEvent: PageEvent;loading:boolean=true;roleStatus=false;circle='';sheetCircle=[];
  pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;myrole:string;submitted = false;adminRole:boolean=true;s3url:string='';
  search:string;bd:string;start_date:string='';end_date:string='';width=200;
  bds_copy=[];copyData:boolean= false;LeadId;treatmentCategoryAccess:string;
  datanew=[];isCMAccess:string;allLabTest=[];allLabTest_copy=[];followup_start_date:string='';followup_end_date:string=''; bd_filter=[]; status_filter=[]; circle_filter=[]; category_filter=[];
  circle_data_filter='';bd_data_filter='';status_data_filter='';category_data_filter='';updatedLodData=[];history_loading:boolean=true;history_loaded:boolean=false;lead_category_filter='';treatCategory=[];alltreatments=[];treatments_copy=[];treatment='';payment_mode:string;lead_sources=[];lead_source:any;paymentOpt=[];nimbus_click_to_call_loading:boolean=false;nimbus_end_to_call_btn_disable=false;click_to_call_loading:boolean=false;response_call_id='';end_to_call_btn_disable=false;shareApp_loading:boolean=false;progression_msg='';

  constructor(private labapi: LabService,private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,public miscapi:MiscService,private router: Router)
  {
      this.sharedapi.getRole()
      .subscribe((item:string) => {this.myrole=item;});
      this.myrole = localStorage.getItem('role');
      this.isCMAccess = localStorage.getItem('CMAccess');
      if(this.myrole=='2')
      {
          this.roleStatus = true;
      }else if(this.myrole=='1')
      {
          this.adminRole = false;
      }

      this.treatmentCategoryAccess = localStorage.getItem('treatment_catergory_access');
      //this.ActionOpt = ['Select','Post Lab Test','Move Lead'];
      this.ActionOpt = ['Select','Post Lab Test','Share Payment Link'];
       
      this.gender=['Male','Female'];
      this.userId = localStorage.getItem('loginuserId');
      this.s3url = localStorage.getItem('s3url');
      this.paymentOpt = ['Cash','Cashless','Reimbursement','EMI'];
      this.loadCommonData();
      this.loadCommonDataForFilter();
      this.getTreatmentCategory();
      this.getTreatment();
      this.getLeadSources();
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
      this.loadleads(0,25);
  }



  async loadleads(pageIndex,perpage)
  {

      this.leads = [];
      this.paginator.pageIndex = pageIndex;
      this.paginatorBottom.pageIndex = pageIndex;
      this.pageIndex = pageIndex;
      let qString ='search='+this.search+'&date_range='+this.start_date+'-'+this.end_date+'&followup_date_range='+this.followup_start_date+'-'+this.followup_end_date+'&bd='+this.bd_data_filter+'&circle='+this.circle_data_filter+'&status='+this.status_data_filter+'&category='+this.category_data_filter+'&lead_source='+this.lead_source+'&treatment='+this.treatment+'&lead_category_filter='+this.lead_category_filter+'&payment_mode='+this.payment_mode;
      this.loading = true;this.loaded = false;
      this.labapi.getLabLeadsSheet(pageIndex,perpage,qString).subscribe((data:any) => {
          this.length = parseInt(data.totaldata);
          this.loading = false;
          this.loaded = true;
          if(data.status)
          {
              this.leads = data.data;
                if(this.myrole=='6' || this.myrole=='18'){
                    this.hideColumn = {columns: [2],indicators: true};
                }
      
          }else{
              this.leads = [];
              this.sharedapi.presentToast(data.msg);
          }
      }, error => {
          this.loading = false;
          this.loaded = true;
          this.sharedapi.checkError(error);
      });
  }


  async loadCommonData()
  {
      await this.labapi.getLabCommonData().subscribe((data:any) => {
          if(data.status)
          {
              this.bds = data.bd;
              this.leadStatusOpt = data.lead_status;
              this.sheetCircle = data.circle;
              this.allLabTest = data.lab_test;
          }else{
              this.bds = [];
              this.leadStatusOpt = [];
              this.sheetCircle = [];
              this.allLabTest =[];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async loadCommonDataForFilter()
  {
      await this.labapi.getLabCommonDataForFilter().subscribe((data:any) => {
          if(data.status)
          {
            this.bd_filter=data.bd; 
            this.status_filter=data.lead_status; 
            this.circle_filter=data.circle; 
            this.category_filter=data.lab_category;
          }else{
            this.bd_filter=[]; 
            this.status_filter=[]; 
            this.circle_filter=[]; 
            this.category_filter=[];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  pageChange(event)
  {
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }

  public getServerData(event:PageEvent):any
  {
      this.perpage = event.pageSize;
      this.pageIndex = event.pageIndex;
      this.loadleads(event.pageIndex,event.pageSize);
  }



  openLabTestDialog(lead_id)
  {
      const dialogRef = this.dialog.open(LabTestModalComponent, {
          width: '100%',height: '90%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  openMoveSurgeryLead(lead_id)
  {
      const dialogRef = this.dialog.open(MoveSurgeryLeadComponent, {
          width: '60%',height: '50%',
          data:{lead_id:lead_id}
      });

      dialogRef.afterClosed().subscribe(result => {
          console.log(result);
      });
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
        //   this.loadleads(0,this.perpage);
      }
  }

  followupdateRangeChange(followupdate1,followupdate2)
  {
      if(followupdate2.value)
      {
          this.followup_start_date = followupdate1.value;
          this.followup_end_date = followupdate2.value;
        //   this.loadleads(0,this.perpage);
      }
  }

  clearDate(type)
  {
      if(type=='created_on'){
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
      } else if(type=='followup'){
        this.followupdateRangeStart.nativeElement.value = "";
        this.followupdateRangeEnd.nativeElement.value = "";
        this.followup_start_date = '';
        this.followup_end_date = '';
      }
      
      this.loadleads(0,this.perpage);
  }

  onBeforeChange = (hotInstance, changes) =>
  {
      let data= this.hotRegisterer.getInstance(this.id).getSourceData();
      let saveData = {id:data[hotInstance[0][0]].id,field_name:hotInstance[0][1],old_value:hotInstance[0][2],new_value:hotInstance[0][3],index:hotInstance[0][0]};
      this.saveOnChange(saveData);
  }

async saveOnChange(saveData)
{
    console.log(saveData);
    if(saveData.field_name=='action')
    {
        if(saveData.new_value=='Post Lab Test')
        {
            this.openLabTestDialog(saveData);
        }
        else if(saveData.new_value=='Share Payment Link'){
            console.log('Share Payment Link');
            this.sharePaymentLink(saveData.id,4)
        }
        else{
            //this.openMoveSurgeryLead(saveData);
        } 
    }else{
         this.updateSingleData(saveData);
    }
    
}

sharePaymentLink(lead_id,type){
    const dialogRef = this.dialog.open(LabPaymentModalComponent, {
        width: '45%',
        height: '50%',
        data:{lead_id:lead_id,type:type}
    });
    dialogRef.afterClosed().subscribe(result => {
        console.log(result);
    });
}

  updateSingleData(saveData){
      console.log(saveData);
      this.submitted = true;
          this.labapi.updateSingleData(saveData).subscribe((data:any) =>
          {
              this.submitted = false;
              if((saveData.field_name == "description" && saveData.new_value!='') || (saveData.field_name != "description"))
                this.sharedapi.presentToast(data.msg);
          }, error => {
              this.sharedapi.checkError(error);
          });
  }

  hideModalTest()
  {
      $('#myModalfb').modal('hide');
  }

  showModalTest()
  {
      $('#myModalfb').modal();
  }

  hideModalAddLead()
  {
      $('#myModalAddLead').modal('hide');
  }

  showModalAddLead()
  {
      $('#myModalAddLead').modal();
  }


  async selectFileLabTest(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.labapi.uploadcsvLabTest(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadTest.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalTest();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

    open_sub_category_modal()
    {
        const dialogRef = this.dialog.open(AddSubcategoryComponent, {
            width: '50%',height: '50%',
            data:{},
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            this.loadleads(0,this.perpage);
        });
    }

    open_category_modal()
    {
        const dialogRef = this.dialog.open(AddCategoryComponent, {
            width: '50%',height: '50%',
            data:{},
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            this.loadleads(0,this.perpage);
        });
    }

    afterOnCellMouseDownCallBack = (event, coords, TD) =>
    {
        if(event.target.nodeName.toLowerCase() == 'a'){
            let leadIId = event.target.attributes.id.nodeValue;
            this.openleadHistoryPopup(leadIId);
        }
        if(event.target.className == 'nimbus_click_to_call')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.lab_nimbus_click_to_call_function(leadId);
            
        }
        if(event.target.className == 'send_applink')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.shareLabAppLink(leadId);
            
        }

        if(event.target.className == 'click_to_call')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.click_to_call_function(leadId);
            
        }
        if(event.target.className == 'share_plan')
        {
            let leadId = event.target.attributes.id.nodeValue;
            this.openPlanShareModal(leadId);
            
        }
    }

    openPlanShareModal(lead_id)
    {
        const dialogRef = this.dialog.open(PlanShareModalComponent, {
            width: '35%',height: '35%',
            data:{lab_lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            //this.loadleads(0,this.perpage);
        });
    }

    shareLabAppLink(lead_id){
        this.shareApp_loading = true;
        let lead_id_arr = {'lab_lead_id': lead_id};
        this.leadapi.share_lab_lead_app_link(lead_id_arr).subscribe((data:any) => {
            this.shareApp_loading = false;
            if(data.status){
                this.sharedapi.presentToast(data.msg);
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        }); 
    }

    lab_nimbus_click_to_call_function(lead_id)
    {
        this.nimbus_click_to_call_loading = true;
        let nimbus_lead_id_arr = {'lead_id': lead_id};
        $("#nimbus_click_to_call_progress").modal("show");
        this.labapi.nimbusClickTOCallForLabLeads(nimbus_lead_id_arr).subscribe((data:any) => {
            this.nimbus_click_to_call_loading = false;
            if(data.status==false){
                $("#nimbus_click_to_call_progress").modal("hide");
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endNimbusClicktoCall()
    {
        this.end_to_call_btn_disable = true;
        $('#nimbus_click_to_call_progress').modal('hide');
        this.end_to_call_btn_disable = false;
    }

    closeHistoryPopup()
    {
        $('#myHistoryModal').modal('hide');
    }

    openleadHistoryPopup(leadIId)
    {
        this.history_loading = true;this.history_loaded = false;
        this.labapi.getFullLabLeadHistory(leadIId).subscribe((data:any) => {
            this.history_loading = false;
            this.history_loaded = true;
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        $('#myHistoryModal').modal();
    }

    exportData()
    {
        if(this.leads.length>0)
        {
            let data = [];
            let titles = [
                'Glamyo Patient Id', 'Patient Name', 'Lead Created Time', 'Patient Age', 'Gender', 'City Name','To Circle', 'Treatment', 'Treatment Category', 'Payment Mode', 'Lead Owner Email', 'Description', 'BD Description', 'Test Category','Test Subcategory', 'Lab Name', 'Followup Date', 'Sample Collection Date/Test','Report Generated Date','Lead Status','Booking Amount','Due Amount','Balance','Extra Payment','Revenue','UTM Campaign','UTM Mediumn'
            ];
            data.push(titles);
            for(let key in this.leads)
            {
                let exdata = [
                    this.leads[key].glamyo_patient_id.replace(/<[^>]*>/g, ''),
                    this.leads[key].lead_name,
                    this.leads[key].created_at,
                    this.leads[key].patient_age,
                    this.leads[key].gender,
                    this.leads[key].city_name,
                    this.leads[key].lead_circle,
                    this.leads[key].treatment_name,
                    this.leads[key].treatment_categories_name,
                    this.leads[key].payment_mode,
                    this.leads[key].bd_email,
                    this.leads[key].description,
                    this.leads[key].bd_description,
                    this.leads[key].category_test_name,
                    this.leads[key].test_name,
                    this.leads[key].lab_name,
                    this.leads[key].followup_date,
                    this.leads[key].sample_collection_date,
                    this.leads[key].report_generated_date,
                    this.leads[key].lead_status_name,
                    this.leads[key].booking_amount,
                    this.leads[key].due_amount,
                    this.leads[key].balance,
                    this.leads[key].extra_payment,
                    this.leads[key].revenue,
                    this.leads[key].utm_campaign,
                    this.leads[key].utm_medium
                ];
                data.push(exdata);
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
            /* save to file */
            let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
            XLSX.writeFile(wb, 'lab_lead_'+utc+'.xlsx');
        }
        else
        {
            this.sharedapi.presentToast('No data found!!');
        }
    }
    setSearchValue(type){
        if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.alltreatments= this.treatments_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'treatment') {
            this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.alltreatments = data.data;
                this.treatments_copy = this.alltreatments;
            }else{
                this.alltreatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getLeadSources()
    {
        let uri = '';
        uri = "none";

        this.leadapi.getUpdatedLeadSources(uri).subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    resetFilters(){
        this.clearDate("created_on");
        this.clearDate("followup");
        this.search = ''; this.lead_source = '';  this.bd_data_filter = ''; this.circle_data_filter = ''; this.status_data_filter=''; this.lead_category_filter = ''; this.category_data_filter = ''; this.treatment = ''; this.payment_mode = '';
        this.loadleads(0,25);
    }


    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.labapi.kaleyraClickTOCall(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            // console.log(data);
            if(data.status){
                this.response_call_id = data.call_id;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.labapi.kaleyraEndClicktoCall(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
                // if(data.status){
                //     if(data.data.data.length > 0) {
                //         if(data.data.data[0].duration > 0) {
                //             this.response_call_id = '';
                //             $('#click_to_call_progress').modal('hide');
                //             this.loadleads(0,this.perpage);
                //         } else {
                //             this.progression_msg = "Please cut the call from mobile first, then click on end call here.";
                //         }
                //     } else {
                //         this.progression_msg = "Phone is ringing, You cannot end the call yet. If you remove popup, can reload the page.";
                //     }
                // } else {
                //     this.sharedapi.presentToast(data.msg);
                // }
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }

    async selectFileLabLeads(event)
  {
      this.submitted = true;
      let file = event.target.files.item(0);
      const formData = new FormData();
      formData.append('file', file);
      this.labapi.uploadcsvLabLeads(formData)
      .subscribe((data:any) => {
          this.submitted = false;
          this.csvUploadLead.nativeElement.value = "";
          if(data.status)
          {
              this.hideModalAddLead();
              this.sharedapi.presentToast(data.msg);
          }
          else
          {
              this.sharedapi.presentToast(data.msg);
          }
        }, error =>
          {
              this.sharedapi.checkError(error);
          });
  }

}
